export const ADMIN_LOGIN_ERROR_MESSAGE =
  "Please check your email and password and try again.";

export function resolveAdminLoginErrorMessage(data: {
  error?: unknown;
  details?: unknown;
}): string {
  const details =
    typeof data.details === "string" ? data.details.trim() : "";
  const error = typeof data.error === "string" ? data.error.trim() : "";
  const raw = details || error;
  if (
    !raw ||
    /unexpected error/i.test(raw) ||
    error === "Internal Server Error"
  ) {
    return ADMIN_LOGIN_ERROR_MESSAGE;
  }
  return raw;
}
